import Vue from 'vue';
import highlighter from '../../utils/highlighter';
import ensureArray from 'src/utils/arrayOperations/ensureArray';
import scrollIntoViewIfItIsNot from 'src/utils/domOperations/scrollIntoViewIfItIsNot';
export default Vue.extend({
    props: {
        titleProp: { type: String, default: null },
        subtitleProp: { type: String, default: null },
        singleSelectProp: { type: Boolean, default: true },
        filtersProp: { type: Object, default: null },
        displayedListLimitProp: { type: Number, default: 30 }
    },
    data() {
        return {
            visible: false,
            needle: undefined,
            dataParam: undefined,
            handleSelectorValueSelection: undefined,
            titleParam: undefined,
            focusedItemIndex: 1,
            cellProps: undefined,
            selectedIds: [],
            initialSelectedIds: []
        };
    },
    computed: {
        displayItemsCount() { return this.dataToDisplayLength || 0; },
        totalItemCount() { var _a; return ((_a = this.dataParam) === null || _a === void 0 ? void 0 : _a.length) || 0; },
        dataComputed() {
            const { filtersProp, dataParam } = this;
            const filtersPropKeys = filtersProp && Object.keys(filtersProp); // filtersProp is v0 implementation of filterModelProp (v1)
            const src = ensureArray(dataParam).filter((r) => !r.is_disabled);
            const src2 = (src[0] && Object.keys(src[0]).includes('ui_sort_order_number'))
                // @ts-ignore
                ? src.sort((a, b) => (a.ui_sort_order_number || 0) - (b.ui_sort_order_number || 0))
                : src;
            const src3 = filtersPropKeys
                ? src2.filter((r) => filtersPropKeys.every((field) => r[field] === filtersProp[field]))
                : src2;
            if (!this.needle || this.needle === '')
                return (src3 || []);
            // @ts-ignore
            return ((src3 || []).filter(r => { var _a; return (_a = r.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(this.needle || ''); }) || []);
        },
        dataToDisplay() {
            const data = this.dataComputed || [];
            return data.slice(0, this.displayedListLimitProp) || [];
        },
        dataToDisplayLength() {
            const data = this.dataToDisplay || [];
            const result = data.length || 0;
            return result;
        },
        title() {
            var _a, _b;
            if (this.multiSelectMode)
                return String((_b = (_a = this.cellProps) === null || _a === void 0 ? void 0 : _a.col) === null || _b === void 0 ? void 0 : _b.label) || '';
            return this.titleParam || this.titleProp || '';
        },
        dataLength() { var _a; return ((_a = this.dataComputed) === null || _a === void 0 ? void 0 : _a.length) || 0; },
        multiSelectMode() { var _a, _b; return ((_b = (_a = this.cellProps) === null || _a === void 0 ? void 0 : _a.col) === null || _b === void 0 ? void 0 : _b.multiSelect) || false; },
        selectedIdsHaveChanged() {
            return this.selectedIds.some(id => !this.initialSelectedIds.includes(id)) || this.initialSelectedIds.some(id => !this.selectedIds.includes(id));
        }
    },
    watch: {
        needle(val) { if (this.needle && val)
            this.needle = val.toLowerCase(); },
        visible(val) {
            if (val) {
                this.focusInput();
                setTimeout(() => {
                    scrollIntoViewIfItIsNot('item' + this.focusedItemIndex, 'topSection', 'bottom', 'mainCard', 'bottom');
                }, 200);
                window.addEventListener('wheel', this.handleWheelEvent);
            }
            else {
                window.removeEventListener('wheel', this.handleWheelEvent);
            }
        },
        dataToDisplayLength(val) {
            if (val !== undefined && val !== null && this.focusedItemIndex > val && val > 1)
                this.focusedItemIndex = val - 1;
        },
        focusedItemIndex(val) {
            setTimeout(() => {
                scrollIntoViewIfItIsNot('item' + val, 'topSection', 'bottom', 'mainCard', 'bottom');
            }, 200);
        }
    },
    methods: {
        highlighter,
        toggleItemInSelectedIds(id) {
            if (this.selectedIds.includes(id)) {
                this.selectedIds = this.selectedIds.filter(r => r !== id);
            }
            else {
                this.selectedIds.push(id);
            }
        },
        handleWheelEvent(event) {
            if (event.deltaY < 0)
                this.moveFocusedItemIndexUp();
            if (event.deltaY > 0)
                this.moveFocusedItemIndexDown();
        },
        open(params) {
            this.openDialog(params || {});
        },
        openDialog(params) {
            const currentValueParam = params.currentValueParam;
            const dataParam = params.dataParam;
            const titleParam = params.titleParam;
            const handleSelectorValueSelection = params.handleSelectorValueSelection;
            const cellProps = params.cellProps;
            this.dataParam = [...ensureArray(dataParam)];
            this.titleParam = titleParam;
            this.handleSelectorValueSelection = handleSelectorValueSelection;
            this.cellProps = cellProps;
            this.visible = true;
            this.needle = undefined;
            if (this.multiSelectMode) {
                let arr = [];
                if (!currentValueParam) {
                    arr = [];
                }
                else if (Array.isArray(currentValueParam)) {
                    arr = currentValueParam;
                }
                else {
                    console.error('Unclear how to handle currentValueParam');
                }
                if (arr.length > 0)
                    arr = arr.map(r => Number(r));
                this.selectedIds = [...arr];
                this.initialSelectedIds = [...arr];
            }
            else {
                Vue.nextTick(() => {
                    const dataToDisplay = this.dataToDisplay || [];
                    if (currentValueParam) {
                        this.focusedItemIndex = dataToDisplay.findIndex(r => String(r === null || r === void 0 ? void 0 : r.id) === String(currentValueParam));
                    }
                });
            }
        },
        handleClickOnItem(item) {
            if (item.disabled) {
                this.$q.notify({ type: 'error', message: 'Cannot select disabled item' });
                return;
            }
            if (!this.multiSelectMode && this.handleSelectorValueSelection && this.singleSelectProp && (typeof item.id === 'string' || typeof item.id === 'number')) {
                this.handleSelectorValueSelection(item.id);
                this.reset();
            }
        },
        focusInput() {
            Vue.nextTick(() => {
                const el = this.$refs.needleInput;
                if (!el)
                    return;
                // @ts-ignore
                el.focus();
                // @ts-ignore
                el.select();
            });
        },
        moveFocusedItemIndexUp() {
            if (this.focusedItemIndex > 0) {
                this.focusedItemIndex -= 1;
            }
            else {
                this.focusInput();
                scrollIntoViewIfItIsNot('title', 'topSection', 'bottom', 'mainCard', 'bottom');
            }
        },
        moveFocusedItemIndexDown() {
            if (this.focusedItemIndex < this.dataLength - 1) {
                this.focusedItemIndex += 1;
            }
        },
        selectFocusedItem() {
            this.handleClickOnItem(this.dataToDisplay[this.focusedItemIndex]);
        },
        reset() {
            this.visible = false;
            this.needle = undefined;
        }
    }
});
